import useEmployeeActions from "./useEmployeeActions"
import useEmployeeActivationActions from "./useEmployeeActivationActions"
import useEmployeeDeactivationActions from "./useEmployeeDeactivationActions"
import useFileActions from "./useFileActions"
import usePayrollActions from "./usePayrollActions"
import {userHasAuthorization} from "../util/role";
import {useAppSelector} from "../redux/hooks";
import useCustomerActions from "./useCustomerActions"
import { useEffect } from "react"
import useFortnoxIntegrationActions from "./integrations/useFortnoxIntegrationActions"
import usePlandayIntegrationActions from "./integrations/usePlandayIntegrationActions"
import useCompanyGroupActions from "./useCompanyGroupActions"
import useCompanyGroupEmployeeDeactivationActions from "./useCompanyGroupEmployeeDeactivationActions"

const useInitialDataFetch = () => {
    const { getPendingEmployees: getEmployeesPendingActivation } = useEmployeeActivationActions()
    const { getPendingEmployees: getEmployeesPendingDeactivation } = useEmployeeDeactivationActions()
    const { getPendingEmployees: getPendingCompanyGroupDeactivations } = useCompanyGroupEmployeeDeactivationActions()
    const { getCustomer } = useCustomerActions()
    const { getCompanyGroup} = useCompanyGroupActions()
    const { getEmployees } = useEmployeeActions()
    const { getPayrollData } = usePayrollActions()
    const { getCustomerFiles } = useFileActions()
    const user = useAppSelector(state => state.auth.authenticatedUser)
    const currentCustomerId = useAppSelector(state => state.auth.currentCustomerId)
    const currentCompanyGroupId = useAppSelector(state => state.auth.currentCompanyGroupId)
    const customer = useAppSelector(state => state.customer.customer)
    const { getStatus: getFortnoxStatus } = useFortnoxIntegrationActions()
    const { getStatus: getPlandayStatus } = usePlandayIntegrationActions ()

    const fetchData = () => {
        if (!user) {
            return
        }

        if (currentCustomerId != null) {
            getCustomer()
            getEmployees()
            getCustomerFiles()

            if (userHasAuthorization(user, currentCustomerId, role => role.allowManageEmployeeActivations)) {
                getEmployeesPendingActivation()
                getEmployeesPendingDeactivation()
            }

            if (userHasAuthorization(user, currentCustomerId, role => role.allowManagePayroll)) {
                getPayrollData()
            }
        } else if (currentCompanyGroupId != null) {
            getCompanyGroup()
            getPendingCompanyGroupDeactivations()
        }
    }

    useEffect(() => {
        if (customer != null) {
            if (customer.portalIntegrations?.includes('Fortnox')) {
                getFortnoxStatus()
            }
    
            if (customer?.portalIntegrations?.includes('Planday')) {
                getPlandayStatus()
            }
        }
    }, [customer])

    return {
        fetchData
    }
}

export default useInitialDataFetch
